import { msalInstance } from "@/modules/msal/msalAuthConfig"

export function getUsername(): string | undefined {
  const account = msalInstance.getActiveAccount()
  return account?.username
}
